// import '../../mock/discoverydata.js'
// import request from '@/utils/request'
import {selfRequest} from '@/utils/selfRequest'
// import selfRequest_hoge from '@/utils/selfRequest'


export function getJson(parameter) {
  return selfRequest(parameter)
}
// export function getDiscovery() {
//   // return selfRequest(parameter, topicApi.topicList)
//   return request({
//     url: '/getdiscovery',
//     method: 'post'
//   })
// }